import { ref } from "vue";
import { useStore } from "@/store";
const store = useStore();
import api from "@/api";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { notify } from "@kyvg/vue3-notification";
import moment from "moment";
import $ from "jquery";

const activeRowModal: any = ref({});
const data = {
  readyToUseFilters: {},
  filter: {
    ignoreSaveFilter: true,
    title: "policyChangeChecklistFilter",
    pageName: "policyChangeChecklistPage",
    genre: "policyChangeChecklist",
    filters: [
      {
        title: "companySiteGroup",
        type: "siteAndGroup",
        selectedLabel: null,
        vmodel: "",
        param: "groupGuid",
        apiEquivalent: "groupIds",
        data: [],
      },
      {
        title: "Time Range",
        type: "date",
        param: "range",
        apiEquivalent: "range",
        hidden: true,
        vmodel: null,
      }
    ],
  },
  models: {
    draftUpdate: {
      riskLevel: 0,
      permissionLevel: 0,
      allowSigned: 0,
      allowTpl: 0,
      memoryGuard: 0,
      notes: null,
    },
  },
  header: {
    navigation: [
      {
        title: "draftreviews",
        url: "policy-change-checklist/draftreviews",
      },
      {
        title: "completed",
        url: "policy-change-checklist/completed",
      },
      {
        title: "deleted",
        url: "policy-change-checklist/deleted",
      },
    ],
  },
  component: {
    type: "ag-table",
    options: {
      columns: [
        {
          label: "Edit",
          field: "edit",
          components: [
            {
              component: "tableExpandComponent",
            },
          ],
          display: function (row: any) {
            activeRowModal.value.data = row;
          },
        },
        {
          label: "risklevel",
          field: "riskLevel",
          sortable: false,
          display: function (e: any) {
            if (e.riskLevel == 0) return "<div style='' class='pt-1 pb-1 pr-2 pl-2 border-radius-0 text-white policy-risk-card risklevel low '>Low</div>";
            if (e.riskLevel == 2)
              return "<div class='pt-1 pb-1 pr-2 pl-2 border-radius-0 text-white policy-risk-card risklevel medium'>Medium</div>";
            if (e.riskLevel == 4)
              return "<div class='pt-1 pb-1 pr-2 pl-2 border-radius-0 text-white policy-risk-card risklevel high'>High</div>";
          },
        },
        {
          label: "status",
          // field: "status",
          sortable: false,
          components: [
            {
              component: "tableStatusChanger",
            },
          ],
        },
        {
          label: "blocktype",
          field: "blockType",
          sortable: false,
        },
        {
          label: "actor",
          field: "actorName",
          sortable: false,
        },
        {
          label: "target",
          field: "targetName",
          sortable: false,
        },
        // {
        //   label: "remarks",
        //   field: "remarks",
        //   sortable: false,
        //   components: [
        //     {
        //       component: "tableRowLinks",
        //       links: [
        //         {
        //           title: "Allow Signed Only, ",
        //           direction: "",
        //         },
        //         {
        //           title: " Add publisher to TLP.",
        //           direction: "",
        //         },
        //       ],
        //     },
        //   ],
        // },
        // {
        //   label: "intrustedlist",
        //   field: "intrustedlist",
        //   sortable: false,
        //   components: [
        //     {
        //       component: "tableTrustedListStatus",
        //       status: false
        //     },
        //   ]
        // }
      ],
      dateFilter: true,
      rows: [],
      total: 10000,
      sortable: {
        order: "",
        sort: "asc",
      },
      page: 1,
      pageSize: 5,
      isLoading: true,
      fetchTable: async (options: any) => {
        //console.log("load table", options);
        const filters = data.readyToUseFilters; //data.filter
        const body = { filters, options };
        store.dispatch(GeneralActionTypes.GET_POLICY_CHECK_LIST, body);
      },
    },
  },
  modals: [
    {
      id: "exampleModalCenter",
      action: {
        label: "Save",
        function: async function (arg: any) {
          const body = {
            id: activeRowModal.value.data.id,
            riskLevel: data.models.draftUpdate.riskLevel,
            permissionLevel: data.models.draftUpdate.permissionLevel,
            allowSigned: data.models.draftUpdate.allowSigned,
            allowTpl: data.models.draftUpdate.allowTpl,
            memoryGuard: data.models.draftUpdate.memoryGuard,
            notes: data.models.draftUpdate.notes,
            changeReason: null,
          };
          $($('#exampleModalCenter')[0]).removeClass("show");
          $($('#exampleModalCenter')[0]).css("display", "none");
          $('body').removeClass('modal-open');
          $('.modal-backdrop').remove();
          notify({
            title: "Saved",
            type: "success",
            duration: 4000,
          });
          await store.dispatch(GeneralActionTypes.UPDATE_REVIEW, body);
        },
      },
      display: function (row: any) {
        activeRowModal.value.data = row;
      },
      cancel: {
        label: "Close",
      },
      active: 0,
      items: [
        {
          title: "draftreview",
          component: "ag-draft-update",
          options: { activeRowModal },
        },
      ],
    },
  ],
};

export default data;
